
export const lipana_signup = ()=>{
    let url = 'http://app.lipana.co.ke/signup'

    return url
}

export const lipana_login = ()=>{
    let url = 'http://app.lipana.co.ke/login'

    return url
}

export const api_link = ()=>{
    let url = process.env.REACT_APP_BASEURL;

    return url
}
